import { ArrowUpRight, ArrowDownRight } from "lucide-react";

export const CONCEPTS = {
  by: {
    label: "By",
    microtext: "Origen de los fondos",
    icon: ArrowUpRight,
    color: "emerald",
    hex: "#10b981",
    text: "text-emerald-500",
    bg: "bg-emerald-500/10",
    border: "border-emerald-500/20",
    ring: "ring-emerald-500/30",
  },
  to: {
    label: "To",
    microtext: "Destino del dinero",
    icon: ArrowDownRight,
    color: "rose",
    hex: "#f43f5e",
    text: "text-rose-500",
    bg: "bg-rose-500/10",
    border: "border-rose-500/20",
    ring: "ring-rose-500/30",
  },
};

export const CURRENCIES = ["MXN", "USD", "EUR", "CAD", "GBP", "CRC"];

export const ACCOUNT_TYPES = [
  { value: "debito", label: "Débito" },
  { value: "credito", label: "Crédito" },
  { value: "efectivo", label: "Efectivo" },
  { value: "inversion", label: "Inversión" },
];

export const FREQUENCIES = [
  { value: "semanal", label: "Semanal" },
  { value: "quincenal", label: "Quincenal" },
  { value: "mensual", label: "Mensual" },
  { value: "anual", label: "Anual" },
];

export const INVOICE_STATUS = {
  pendiente: { label: "Pendiente", cls: "bg-amber-500/15 text-amber-500 border-amber-500/30" },
  solicitada: { label: "Solicitada", cls: "bg-sky-500/15 text-sky-500 border-sky-500/30" },
  recibida: { label: "Recibida", cls: "bg-emerald-500/15 text-emerald-500 border-emerald-500/30" },
  cancelada: { label: "Cancelada", cls: "bg-slate-500/15 text-slate-400 border-slate-500/30" },
};
